// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, Navigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const storedLoginStatus = localStorage.getItem('isLoggedIn');
    const storedUserId = localStorage.getItem('userId');

    if (storedLoginStatus !== 'true') {
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
      setUserId(storedUserId);
      fetchCourses(storedUserId);
      fetchAllCourses();
    }
  }, []);

  const fetchCourses = (userId) => {
    if (!userId) return;
    fetch(`https://schoolofservice.co.za/backend/get-enrolled-courses.php?userId=${userId}`)
      .then((response) => response.json())
      .then((data) => setEnrolledCourses(data))
      .catch((error) => console.error('Error fetching enrolled courses:', error));
  };

  const fetchAllCourses = () => {
    fetch('https://schoolofservice.co.za/backend/get-courses.php')
      .then((response) => response.json())
      .then((data) => setAllCourses(data))
      .catch((error) => console.error('Error fetching all courses:', error));
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    navigate('/login');
  };

  const handleEnroll = (courseId) => {
    if (!userId) {
      alert('User ID is missing. Please log in again.');
      return;
    }

    const data = new URLSearchParams({
      userId: userId,
      courseId: courseId,
    });

    fetch('https://schoolofservice.co.za/backend/enroll-course.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          alert('Successfully enrolled in the course!');
          fetchCourses(userId);
        } else {
          alert(`Error: ${data.message}`);
        }
      })
      .catch((error) => {
        console.error('Error enrolling in course:', error);
        alert('An error occurred while enrolling in the course. Please try again.');
      });
  };

  if (isLoggedIn === null) {
    return <div className="text-center my-5">Loading...</div>;
  }
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="d-flex">
      <aside className="bg-light" style={{ width: '250px', height: '100vh', boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)' }}>
        <h3 className="text-center py-4 border-bottom">Dashboard</h3>
        <nav className="d-flex flex-column px-3">
        <Link 
  to="/profile" 
  state={{ userId }} 
  className="btn btn-outline-primary my-2"
>
  View Profile
</Link>

          <Link 
  to={`/test-results?userId=${userId}`} 
  className="btn btn-outline-primary my-2"
>
  Test Results
</Link>

          <button className="btn btn-outline-danger my-2" onClick={handleLogout}>Logout</button>
        </nav>
      </aside>

      <main className="container py-5" style={{ flexGrow: 1 }}>
        <h2 className="text-center mb-4">Welcome to Your Dashboard</h2>

        <h3>Enrolled Courses</h3>
        <div className="d-flex flex-wrap">
          {enrolledCourses.length > 0 ? (
            enrolledCourses.map((course) => (
              <div key={course.coursesID} className="card m-2 p-3">
                <h5>{course.courseName}</h5>
                <button className="btn btn-primary mb-2" onClick={() => navigate(`/course/${course.coursesID}`)}>View Course</button>
                <button className="btn btn-info" onClick={() => navigate(`/QuizList/${course.coursesID}?userId=${userId}`)}>Take Quiz</button>
              </div>
            ))
          ) : (
            <p>No enrolled courses. Explore and enroll below!</p>
          )}
        </div>

        <h3>Available Courses</h3>
        <div className="d-flex flex-wrap">
          {allCourses.length > 0 ? (
            allCourses.map((course) => (
              <button
                key={course.coursesID}
                className="btn btn-outline-success m-2"
                onClick={() => handleEnroll(course.coursesID)}
              >
                Enroll in {course.courseName}
              </button>
            ))
          ) : (
            <p>No courses available at the moment.</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
